// extracted by mini-css-extract-plugin
export var active = "_1h-d";
export var blink = "_1h-e";
export var container = "_1h-5";
export var controls = "_1h-0";
export var controlsRight = "_1h-1";
export var fakeCursor = "_1h-c";
export var hidden = "_1h-b";
export var quillContainerSmall = "_1h-7";
export var quillEditor = "_1h-6";
export var quillEditorSmall = "_1h-8";
export var quillFormatButtons = "_1h-a";
export var quillToolbar = "_1h-9";
export var removePadding = "_1h-2";
export var state = "_1h-3";
export var stateTitle = "_1h-4";